import {Object3D} from "three";
import {
	ActionDescription,
	ActionParameters
} from "../classes/api/APIDecorators";
import Engine from "../classes/Engine";
import {GroupsManager} from "../classes/GroupsManager";
import { CustomEventTypes } from "../globals";
import Action from "../classes/Action";
import {RegisterActionWithAPI} from "../classes/api/Decorators";


@ActionDescription("It will select the objects in selectedObjects and deselect the objects in deselectedObjects. It will also select the group previouslySelectedGroup if it is not null.")
@ActionParameters({selectedObjects: "Object3D[]", deselectedObjects: "Object3D[]",  previouslySelectedGroup: "any"})
@RegisterActionWithAPI("SelectObjectsAction")
export default class SelectObjectsAction extends Action
{
	constructor( selectedObjects: Object3D[], deselectedObjects: Object3D[],  previouslySelectedGroup?: any)
	{
		let actionName = "??";
		if (selectedObjects.length === 0 && deselectedObjects.length > 0)
		{
			if (deselectedObjects.length === 1)
			{
				actionName = "Deselected " + deselectedObjects[0].name;
			}
			else if (Engine.getInstance().getPickingManager().getCurrentSelection().objects.length === 0)
			{
				actionName = "Cleared selection";
			}
			else
			{
				actionName = "Deselected Multiple Objects";
			}
		}
		else if (selectedObjects.length === 1)
		{
			actionName = "Selected " + selectedObjects[0].name;
		}
		else if (selectedObjects.length > 1)
		{
			actionName = "Selected Multiple Objects";
		}
		if (!previouslySelectedGroup)
		{
			previouslySelectedGroup = Engine.getInstance().getPickingManager().getCurrentSelection().groupGuid;
		}

		super([selectedObjects, deselectedObjects, previouslySelectedGroup], [selectedObjects, deselectedObjects, previouslySelectedGroup], actionName, [selectedObjects, deselectedObjects, previouslySelectedGroup], false);
	}

	do(selectedObjects: Object3D[], deselectedObjects: Object3D[], previouslySelectedGroup: any)
	{
		if (previouslySelectedGroup)
		{
			const groupObjects = GroupsManager.getGroupObjects(previouslySelectedGroup, Engine.getInstance().getCurrentScene()!.userData.guid);
			Engine.getInstance().getPickingManager().selectGroup("");
			for (const groupObject of groupObjects)
			{
				if (!deselectedObjects.includes(groupObject))
				{
					Engine.getInstance().getPickingManager().selectObject(groupObject);
				}
			}
		}

		for (const object of deselectedObjects)
		{
			Engine.getInstance().getPickingManager().deselectObject(object);
		}

		for (const object of selectedObjects)
		{
			Engine.getInstance().getPickingManager().selectObject(object);
		}
		Engine.getInstance().getPickingManager().storeSelection();

		document.dispatchEvent(new CustomEvent(CustomEventTypes.objectSelectionChanged));
	}

	undo(selectedObjects: Object3D[], deselectedObjects: Object3D[], previouslySelectedGroup: any)
	{
		if (previouslySelectedGroup)
		{
			Engine.getInstance().getPickingManager().selectGroup(previouslySelectedGroup);
		}
		else
		{
			for (const object of deselectedObjects)
			{
				Engine.getInstance().getPickingManager().selectObject(object);
			}

			for (const object of selectedObjects)
			{
				Engine.getInstance().getPickingManager().deselectObject(object);
			}
		}
		document.dispatchEvent(new CustomEvent(CustomEventTypes.objectSelectionChanged));
	}

	verify(selectedObjects: Object3D[], deselectedObjects: Object3D[], previouslySelectedGroup: any)
	{
		const currentlySelectedGroup = Engine.getInstance().getPickingManager().getCurrentSelection().groupGuid;
		const groupSelectionChanged = (previouslySelectedGroup !== currentlySelectedGroup);
		if (selectedObjects.length === 0 && deselectedObjects.length === 0 && !groupSelectionChanged)
		{
			return false;
		}

		const alreadySelected: Object3D[] = [];
		const alreadyDeselected: Object3D[] = [];
		for (const object of selectedObjects)
		{
			if (Engine.getInstance().getPickingManager().isObjectSelected(object))
			{
				alreadySelected.push(object);
			}
		}

		if (alreadySelected.length === selectedObjects.length && deselectedObjects.length === 0 && !groupSelectionChanged)
		{
			return false;
		}
		else
		{
			for (const object of alreadySelected)
			{
				const index = selectedObjects.indexOf(object);
				if (index > -1)
				{
					selectedObjects.splice(index, 1);
				}
			}
			for (const object of alreadyDeselected)
			{
				const index = deselectedObjects.indexOf(object);
				if (index > -1)
				{
					deselectedObjects.splice(index, 1);
				}
			}
		}

		return true;
	}
}
